(function() {

    'use strict';


    /*global console:false */



    var SWF = SAPO.Utility.SWF;



    var AdWrapperFlash = function(o) {
        //console.log('TODO VPAIDAdWrapperFlash options', o);


        // START

        /*var js = function(o) {
            return JSON.stringify(o);
        };*/

        var ad, adw, subscribers = {};
        var pendingResize;

        var onEvent = function(evJSON) {
            /*jshint maxcomplexity:40 */

            var ev = JSON.parse(evJSON);

            //console.log('***', ev.type);

            switch (ev.type) {
                case 'WrapperReady':

                    console.log('WrapperReady', o.adDims, pendingResize);

                    ad.handshakeVersion('2.0');

                    //ad.initAd(adDims[0], adDims[1], 'normal', -1, 'frameRate=15&duration=20', null);
                    //console.log(o.adDims[0], o.adDims[1], o.viewMode, o.creativeData, o.environmentVars);

                    try {
                        if (pendingResize) {
                            o.adDims = pendingResize;
                        }

                        ad.initAd(
                            o.adDims[0],
                            o.adDims[1],
                            o.viewMode,
                            o.creativeData,
                            o.environmentVars
                        );
                        console.log('PASSED');
                    } catch (ex) { // TODO WEIRD HACK
                        ad.resizeAd(o.adDims[0], o.adDims[1], o.viewMode);
                    }

                    ad.startAd(); // TODO because AdLoaded not called. should be triggered on timeout only

                    break;

                case 'AdLoaded': // TODO OPEN ISNT CALLING THIS
                    ad.startAd();
                    break;
            }

            adw.fire(ev);
        };

        var onEventName = 'onEvent_' + ~~(Math.random() * 10000);
        window[onEventName] = onEvent;


        ad = SWF.embed({
            swf:       '//' + SV_DOMAIN + ( window.location.port ? ( ':' + window.location.port ) : '' ) + '/Projects/Video/' + SV_VERSION + '/flash/VPAIDAdUnitWrapper.swf',
            dims:      o.adDims,                   // dimensions in pixels
            //id:        'vpaid',                  // id and name for object element (if ommitted, random one will be generated)
            container: o.container,            // container element
            params: { // params
                allowfullscreen:   true,          // if trueish, allowfullscreen param is set to true
                allowscriptaccess: 'always',      // allowscriptaccess param
                wmode:             'transparent', // wmode param: opaque | transparent | window
                //bgcolor:           '#FF0000',     // bgcolor param
                //quality:           'high'         // quality param
            },
            flashvars: { // flashvars
                onEvent: onEventName, // function that will be called on every flash event reported by the ad
                swf:     o.adURL,     // the ad to load and wrap
            },
            insteadOf: false // if true, repaces container, otherwise appends container
        });



        adw = {
            subscribe: function(cb, evName, ctx) {
                //console.log('subscribe', evName);
                var bag = subscribers[evName];
                var isNew = !bag;
                if (isNew) { bag = []; }
                bag.push([cb, ctx]);
                if (isNew) { subscribers[evName] = bag; }
            },

            subscribeSane: function(evName, cb, ctx) { // HELPERS
                this.subscribe(cb, evName, ctx);
            },
            unsubscribeSane: function(evName, cb) {
                this.unsubscribe(cb, evName);
            },

            unsubscribe: function(cb, evName) {
                var bag = subscribers[evName];
                if (!bag) { return; }
                var i, pair, I = bag.length;
                for (i = 0; i < I; ++i) {
                    pair = bag[i];
                    if (cb === pair[0]) {
                        bag.splice(i, 1);
                        --I;
                    }
                }
            },

            fire: function(ev) { // internal
                var evName = ev.type;
                var bag = subscribers[evName];
                if (!bag) { return; }
                var i, pair, I = bag.length;
                for (i = 0; i < I; ++i) {
                    pair = bag[i];
                    try {
                        (pair[0] || undefined).call(pair[1], ev);
                    } catch (ex) {
                        console.error(ex);
                    }
                }
            },

            // VPAID 1.0
            getAdLinear:         function() { return ad.getAdLinear(); },
            getAdExpanded:       function() { return ad.getAdExpanded(); },
            getAdRemainingTime:  function() { return ad.getAdRemainingTime(); },
            getAdVolume:         function() { return ad.getAdVolume(); },

            setAdVolume:         function(v) { ad.setAdVolume(v); },

            collapseAd:          function() { ad.collapseAd(); },
            expandAd:            function() { ad.expandAd(); },
            handshakeVersion:    function(v) { return ad.handshakeVersion(v); },
            initAd:              function(w, h, vm, db, cd, ev) { ad.initAd(w, h, vm, db, cd, ev); },
            pauseAd:             function() { ad.pauseAd(); },
            resizeAd:            function(w, h, vm) {
                try {
                    ad.resizeAd(w, h, vm);
                } catch (ex) {
                    pendingResize = [w, h];
                    console.log('left resizeAd'); }
            },
            resumeAd:            function() { ad.resumeAd(); },
            startAd:             function() { ad.startAd(); },
            stopAd:              function() { ad.stopAd(); },

            // VPAID 2.0
            getAdCompanions:     function() { return ad.getAdCompanions(); },
            getAdDuration:       function() { return ad.getAdDuration(); },
            getAdHeight:         function() { return ad.getAdHeight(); },
            getAdIcons:          function() { return ad.getAdIcons(); },
            getAdSkippableState: function() { return ad.getAdSkippableState(); },
            getAdWidth:          function() { return ad.getAdWidth(); }
        };



        if ('onReady' in o) {
            o.onReady(adw);
        }
    };

    SAPO.Project.Video.VAST.VPAID.AdWrapperFlash = AdWrapperFlash;

})();
